import { render, staticRenderFns } from "./VaTextArea.vue?vue&type=template&id=0a808d42&scoped=true&"
import script from "./VaTextArea.vue?vue&type=script&lang=ts&"
export * from "./VaTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a808d42",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a808d42')) {
      api.createRecord('0a808d42', component.options)
    } else {
      api.reload('0a808d42', component.options)
    }
    module.hot.accept("./VaTextArea.vue?vue&type=template&id=0a808d42&scoped=true&", function () {
      api.rerender('0a808d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaTextArea.vue"
export default component.exports